import { h } from 'preact';
import { ReactChildren, ReactChild } from 'react';
import { useMediaQuery } from 'react-responsive'
interface IResponsive {
    children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[] | any;
}

export const Desktop = ({ children }: IResponsive) => {
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return isDesktop ? children : null
}
export const Tablet = ({ children }: IResponsive) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
}

export const Mobile = ({ children }: IResponsive) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
}

export const Default = ({ children }: IResponsive) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
}
